import ProfileSelector from "./core/ProfileSelector";
import { fromJS } from "immutable";
import React, { Component } from "react";

export class Header extends Component {
  constructor(props) {
    super(props);
    this.handleDefinitionChange = this.handleDefinitionChange.bind(this);
  }

  handleDefinitionChange(v) {
    this.props.onChangeDefinition(v);
  }

  render() {
    return (
      <div id="header">
        <div className="navbar navbar-fixed-top">
          <div className="navbar-inner">
            <div className="navbar-logo-container">
              <a>
                <img
                  className="navbar-logo-image"
                  src="Infoway-Bilingual-vbar.png"
                />
              </a>
            </div>
            <div className="navbar-rest-container">
              <a className="brand">Swagger UI</a>
              <div className="swagger-ui servers vertical-center">
                <ProfileSelector
                  controlId="a"
                  value={this.props.currentDefinition}
                  onChange={(v) => this.handleDefinitionChange(v)}
                  profile={fromJS(Object.keys(this.props.definitionList))}
                  className="servers"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
